import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';
import WetSlider from './WetSlider.js';

class ReverbEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reverbEffect: props.reverbEffect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.reverbEffect = nextProps.reverbEffect;
        return true;
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.reverbEffect.isEnabled();
    }

    render() {
        var roomSize = Math.round(this.state.reverbEffect.getRoomSize()*10)/10;
        var dampening = this.state.reverbEffect.getDampening();
        var wet = this.state.reverbEffect.getWet();
        let className = this.props.automation !== undefined ?
            'enabled effect effect-automation' :
            this.state.reverbEffect.isEnabled() ? 'effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                  <EffectParameterSlider   
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        selectedParameter={this.props.selectedParameter}
                        name='Room Size'
                        parameter={this.state.reverbEffect.roomSizeParameter}
                        lfoEnabled={true}
                        sequencerEngine={this.props.sequencerEngine}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.01}
                        max={1}
                        min={0}
                        />
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        selectedParameter={this.props.selectedParameter}
                        name='Dampening'
                        lfoEnabled={true}
                        sequencerEngine={this.props.sequencerEngine}
                        parameter={this.state.reverbEffect.dampeningParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={100}
                        max={8000}
                        min={0}
                        />
                      <WetSlider
                        effectNumber={this.props.effectNumber}
                            sequencerEngine={this.props.sequencerEngine}
                        automation={this.props.automation}
                        selectedParameter={this.props.selectedParameter}
                        onParameterChanged={this.props.onParameterChanged}
                            effect={this.state.reverbEffect}/>
                  </div>} 
            </div>
        );
    }
}

export default ReverbEffect;
